import { FC } from "react";
import TabGroups from "./Variants/TabGroups/TabGroups";
import Dashboard from "./Variants/Dashboard";
import { useSettingsContext } from "../Settings/hooks/useSettingsContext";
import { Navigate } from "react-router";
import { useTranslation } from "react-i18next";

const Home: FC = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();

  switch(Settings?.home?.type) {
    case 'tabGroups':
      return <TabGroups homeSettings={Settings.home}/>
    case 'dashboard':
      return <Dashboard />
    case 'redirectInvoice':
      return <Navigate to={t("common:url.invoices")}/>
    default:
      return <Navigate to={t(`common:url.${Settings?.homepage}`)}/>
  }
}

export default Home;
